module.exports = __webpack_public_path__ + "static/media/empty-coinera.a7c18cb9.svg";